import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { API_CONFIG, ApiConfig } from '../api-config';

export interface ServicesSelectOption {
  value: string;
  label: string;
}

/**
 * Catálogo de servicios para multi-selects.
 * GET {apiUrl}/selects/services → { success, data: [{ id, text }] }
 */
@Injectable({ providedIn: 'root' })
export class ServicesSelectService {
  private readonly httpClient = inject(HttpClient);
  private readonly apiConfig = inject<ApiConfig>(API_CONFIG);
  private readonly cache = new Map<string, ServicesSelectOption[]>();
  private readonly endpointUrl = '/selects/services';

  getOptions(): Observable<ServicesSelectOption[]> {
    const cached = this.cache.get(this.endpointUrl);
    if (cached) return of(cached);

    return this.httpClient
      .get(`${this.apiConfig.apiUrl}${this.endpointUrl}`, {
        observe: 'response',
        responseType: 'text',
      })
      .pipe(
        map((resp) => this.parseSelectResponse(resp.body)),
        tap((options) => this.cache.set(this.endpointUrl, options)),
        catchError(() => of([])),
      );
  }

  private parseSelectResponse(body: unknown): ServicesSelectOption[] {
    if (typeof body !== 'string' || !body) return [];
    try {
      const parsed = JSON.parse(body) as {
        success?: boolean;
        data?: Array<{ id: string; text?: string; label?: string; name?: string }>;
      };
      if (!parsed || parsed.success !== true || !Array.isArray(parsed.data)) {
        return [];
      }
      return parsed.data.map((item) => ({
        value: item.id || '',
        label: item.text || item.label || item.name || '',
      }));
    } catch {
      return [];
    }
  }
}
